import React, { useEffect, useMemo, useRef } from 'react'
import { Animated, DimensionValue, Easing, StyleSheet, View } from 'react-native'
import { getDSColorWithOpacity } from '../../../design-system/Palette'
import { DSColor, Palette } from '@ppwr/poker'
export interface ProgressBarProps {
  duration: number
  maxDuration: number
  backgroundColor: DSColor
  backgroundOpacity?: number
  height?: DimensionValue
  color: DSColor
  onComplete?: () => void
}

export const ProgressBar = ({
  duration,
  maxDuration,
  backgroundColor,
  backgroundOpacity = 1,
  color,
  height = '30%',
  onComplete
}: ProgressBarProps) => {
  const progressBarWidth = useRef(new Animated.Value(0)).current
  const remainingTime = (duration * 100) / maxDuration
  const composition = useMemo(
    () =>
      Animated.timing(progressBarWidth, {
        toValue: 100,
        duration: duration,
        useNativeDriver: false,
        easing: Easing.linear
      }),
    [duration, progressBarWidth]
  )

  useEffect(() => {
    composition.stop()
    progressBarWidth.setValue(100 - remainingTime)
    composition.start(({ finished }) => {
      /* completion callback */
      if (finished && onComplete) {
        onComplete()
      }
    })
    return () => {
      composition.stop()
    }
  }, [duration, composition, progressBarWidth, remainingTime, onComplete])

  return (
    <View
      style={[styles.container, { backgroundColor: getDSColorWithOpacity(backgroundColor, backgroundOpacity), height }]}
    >
      <Animated.View
        style={[
          styles.progressBar,
          {
            backgroundColor: Palette[color],
            width: progressBarWidth.interpolate({
              inputRange: [0, 100],
              outputRange: ['100%', '0%']
            })
          }
        ]}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '30%',
    borderRadius: 10
  },
  progressBar: {
    borderRadius: 10,
    height: '100%'
  }
})
